export default "__VITE_ASSET__BjjGLLyk__"